import React from 'react';
import { TextRow } from '../table';
import { Images } from 'utils';

export const NameAndFolder = ({ src, name, background, filter }) => {
    return (
        <div className="name-and-folder-wrapper">
            <div className="name-and-folder-img-block" style={{ background }}>
                <img src={src || Images.folderMain} alt="folder" style={{ filter }} />
            </div>

            <TextRow name={name} />
        </div>
    );
};
